<script>
import {mapActions} from "vuex";
import UConnectCheckUserDialog from "../uConnectCheckUserDialog.vue";




export default {
  name: "uConnectSetPasswordStep",
  components: {UConnectCheckUserDialog},
  data() {
    return {
      isUserCreated: false,
      subscriptionPeriod: "MONTHLY",
      selectedProductId: "",
      packageSelected: false,
      alertDialogVisible: false,
      dialogBoxMessage: "",
      dialogBoxTitle: "",
      userTypeErrorCode: 0,
      userForm: {
        email: "",
        password: ""
      },
      userFromRules: {
        email: [
          {required: true, message: "Please input your email", trigger: "blur"},
          {type: "email", message: "Please input a valid email", trigger: "blur"}
        ],
        password: [
          {required: true, message: "Please input your password", trigger: "blur"},
          {min: 8, message: "The password must not be less than 8 digits", trigger: "blur"}
        ]
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === '/pricing') {
      console.log("clear user details");
      this.$store.commit("uConnect/clearUserDetails", );
    }
    next()
  },
  mounted() {
    const email = this.$store.state.uConnect.email;
    if(email === null || email === undefined || email === ""){
      this.isUserCreated = false;
      const selectedProductId = localStorage.getItem("selectedProductId");
      const subscriptionPeriod = localStorage.getItem("subscriptionPeriod");
      if(selectedProductId === null || selectedProductId === undefined || selectedProductId === ""){
        this.$router.push({name: "uConnect"});
      }else{
        this.packageSelected = true;
        this.selectedProductId = selectedProductId;
        this.subscriptionPeriod = subscriptionPeriod;
      }

    }else{
      this.isUserCreated = true;
      this.userForm.email = email;
    }

  },
  methods: {
    ...mapActions("uConnect", ["checkUConnectUser","updateUConnectUserDetails", "updateUConnectUserPackageDetails"]),

    validateField(field) {
      this.$refs.userForm.validateField(field);
    },
    goToMoreDetailsStep(formName) {

      this.$refs[formName].validate(valid => {
        if (valid) {
          var uConnectRegistrationKey = localStorage.getItem("uConnectRegistrationKey");
          const params = {
            userId: this.$store.state.uConnect.userId,
            email: this.userForm.email,
            password: this.userForm.password,
            uConnectRegistrationKey: uConnectRegistrationKey,
          }
          this.updateUConnectUserDetails({params, callback: this.updateUConnectUserPasswordCallback})
        }
      });
    },
    updateUConnectUserPasswordCallback(res) {
      if (res.data.code === 0) {
        localStorage.setItem("uConnectRegistrationKey", res.data.data.uConnectRegistrationKey);
        this.$emit('stepChanged', 2);
        this.$router.push({name: 'uConnectMoreUserDetailsStep'});
      }else if (
          res.data.code === 90000 ||
          res.data.code === 90002 ||
          res.data.code === 90001) {
        this.$box.alert('', res.data.message ,'error');
        this.$router.push("/uconnect");
      }
    },
    checkUserAndCreate(formName) {

      console.log("checkUserAndCreate");
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.loading) return;
          this.loading = true;

          this.checkUConnectUser({
            params: {
              email: this.userForm.email,
            },
            callback: this.checkUConnectUserCallback
          });
        }
      });
    },
    checkUConnectUserCallback(res) {

      if (res.data.code === 60001 || res.data.code === 60002) {

        localStorage.setItem("uConnectRegistrationKey", res.data.data.uConnectRegistrationKey);
        this.$store.commit("uConnect/updateUserDetails", {
          user: {
            email: res.data.data.user.email,
            userId: res.data.data.user.userId
          }
        });
        var uConnectRegistrationKey = localStorage.getItem("uConnectRegistrationKey");
        const params = {
          userId: this.$store.state.uConnect.userId,
          email: this.userForm.email,
          password: this.userForm.password,
          uConnectRegistrationKey: uConnectRegistrationKey,
          subscriptionUConnectId: this.selectedProductId,
          paymentInterval: this.subscriptionPeriod

        }

        this.updateUConnectUserPackageDetails({ params, callback: this.updateUConnectUserPackageDetailsCallback })


      } else if (res.data.code === 70000) {
        this.alertDialogVisible = true;
        this.dialogBoxMessage = res.data.message;
        this.userTypeErrorCode = res.data.code;
        this.dialogBoxTitle = "User Account Exists"
        this.loading = false;
      }

    },
    updateUConnectUserPackageDetailsCallback(res) {
      if (res.data.code === 0) {

        this.$store.commit("uConnect/updateSubscribedUConnectId", {
          subscribedUConnectId: res.data.data.user.uconnectSubscriptionId,
        });

        this.$store.commit("uConnect/updateSubscribedUConnectProductCode", {
          subscribedUConnectProductCode : res.data.data.selectedSubscriptionCode,
        })

        this.$emit('stepChanged', 2);
        this.$router.push({name: 'uConnectMoreUserDetailsStep'});

      }
    },
    handleCloseRegisterDialog() {
      this.alertDialogVisible = false;
      this.clearUserDetails();

    },
    clearUserDetails() {
      this.userForm.password = "";
    },
  }
}
</script>

<template>
    <div class="setup-container">
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="12" class="content">
          <p class="step-text">STEP 2 OF 3</p>
          <h2>Create a password to start your UNIFI membership</h2>
          <p class="description">Just a few more steps and you’re finished!</p>

          <el-form ref="userForm" :model="userForm" :rules="userFromRules">
            <el-form-item prop="email">
              <el-input :disabled="isUserCreated" v-model="userForm.email" placeholder="Email"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="userForm.password" placeholder="Create a password" show-password></el-input>
            </el-form-item>
            <el-form-item>
              <el-button  type="primary" class="next-button" @click="isUserCreated ? goToMoreDetailsStep('userForm')
              : checkUserAndCreate('userForm')">Next</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <u-connect-check-user-dialog
          v-if="alertDialogVisible"
          :alertDialogVisible="alertDialogVisible"
          :dialogBoxTitle="dialogBoxTitle"
          :dialogBoxMessage="dialogBoxMessage"
          :userTypeErrorCode="userTypeErrorCode"
          @onClose="handleCloseRegisterDialog"/>
    </div>
</template>

<style scoped lang="css">
/* step2a */
.setup-container {
  padding: 20px;
  text-align: center;
}

.content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.icons {
  font-size: 40px;
  color: #333;
}

.step-text {
  font-size: 14px;
  font-weight: bold;
  color: #555;
  margin-top: 10px;
}

h2 {
  font-size: 22px;
  font-weight: bold;
  margin-top: 10px;
}

.description {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

.next-button {
  margin-top: 20px;
  background: #003333;
  color: #ffffff;
  border: none;
  width: 100%;
  padding: 12px;
  font-size: 16px;
}
/* step2b */
.setup-container {
  padding: 20px;
  text-align: center;
}

.content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.step-text {
  font-size: 14px;
  font-weight: bold;
  color: #555;
  margin-bottom: 10px;
}

h2 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 10px;
}

.description {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.el-input {
  width: 100%;
}
/* tnc */


.tnc-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 90%;

}

.pdf-container {
  width: 100%;
  height: 30%;
  object-fit: contain;
}
.tnc-accept-checkbox {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #003333;
  border-color: #003333;
}
.tnc-accept-checkbox :hover {
  border-color: #003333 !important;
}
.tnc-accept-checkbox /deep/ .el-checkbox__label {
  color: #003333;
}
.tnc-accept-checkbox /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #003333 !important;
  border-color: #003333 !important;
}
.tnc-accept-checkbox /deep/ .el-checkbox__input.is-checked .el-checkbox__inner  {
  background-color: #003333 !important;
  border-color: #003333 !important;

}

.next-button.is-disabled {
  color: #FFF;
  background-color: rgba(0, 51, 51, 0.31);
  border-color: rgba(0, 51, 51, 0.31);
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/steps/userDetailsSteps/uConnectSetPasswordStep.vue